import React, { FunctionComponent } from 'react';

import { VerifyPhoneNumberProvider } from './providers/verify-phone-number.provider';
import { VerifyPhoneForm } from './verify-phone-form';

export const SharedVerifyPhoneNumberPage: FunctionComponent = () => {
  return (
    <VerifyPhoneNumberProvider>
      <VerifyPhoneForm />
    </VerifyPhoneNumberProvider>
  );
};
